import { DrugTagPreparationFate } from '../../dto/DrugTagPrescriptionReportDTO';

/** Destino de lo preparado: los mismos textos que el Excel (PreparationFate en el backend). */
export const PREPARATION_FATE_LABELS: Record<DrugTagPreparationFate, string> = {
    DISCARDED: 'Descartada',
    RETURNED_PREPARED: 'Devuelta como preparada',
    NEVER_DELIVERED: 'Quedó en farmacia',
    NOT_RETURNED: 'Sin devolución en la dosis',
};
